import { render, staticRenderFns } from "./Raychat.vue?vue&type=template&id=2ef07172&scoped=true"
import script from "./Raychat.vue?vue&type=script&lang=js"
export * from "./Raychat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef07172",
  null
  
)

export default component.exports